export default __webpack_public_path__ + "static/logo-b43667294321a4477a752431c3c011ac.png";